/**
 * @param string a string containing placeholders in the format of "{0}, {1}, {2}, etc"
 * @param args a list of values to place into the string on their respective positions
 * @returns formated string
 */
export const format = (string: string, ...args: any[]) =>
  string.replace(/{(\d+)}/g, (match, number) =>
    typeof args[number] !== "undefined" ? args[number] : match
  );
